

export class NewHeart{
    constructor(){

    }

   
     explode = (x, y,width,height,numOfBubbles) => {
         var colors=[
            "#6dcbe8",
            "#ff6060",
            "#addf76",
            "#4ee2bf",
            "#da6aee"];
        // find bubble with id
        
        var bubbles = numOfBubbles;

        let particles = [];
        let ratio = window.devicePixelRatio;
        let c = document.createElement('canvas');
        let ctx = c.getContext('2d');

        c.style.position = 'absolute';
        c.style.left = (x - (width/2)) + 'px';
        c.style.top = (y - (height/2)) + 'px';
        c.style.pointerEvents = 'none';
        c.style.width = width + 'px';
        c.style.height = height + 'px';
        c.style.zIndex = 100;
        c.width = width * ratio;
        c.height = height * ratio;
        document.body.appendChild(c);

        for(var i = 0; i < bubbles; i++) {
            particles.push({
                x: c.width / 2,
                y: c.height / 2,
                radius: this.r(10, 30),
                color: colors[Math.floor(Math.random() * colors.length)],
                rotation: this.r(0, 360, true),
                speed: this.r(0.1, 1),
                friction: 1.01,
                opacity: this.r(0, 0.5, true),
                yVel: 0,
                gravity: -0.1
            });
        }

        this.render(null,c,particles, ctx, c.width, c.height);
    }

    startTimestamp=null;
    previousTimeStamp=null;

     render(timestamp,c,particles, ctx, width, height) {
        if (this.startTimestamp==null) 
        {
            this.startTimestamp=timestamp;
        }
        if (this.previousTimeStamp !== timestamp || this.previousTimeStamp==null) 
        {
        
            const elapsed = timestamp - this.startTimestamp;
            if (elapsed > 10000 && this.startTimestamp!=null) { // Stop the animation after 2 seconds
                document.body.removeChild(c);
                this.startTimestamp=null;    
                this.previousTimestamp=null;
            }
            else{
                this.previousTimeStamp=timestamp;
                requestAnimationFrame((time) => this.render(time,c,particles, ctx, width, height));
                ctx.clearRect(0, 0, width, height);

                particles.forEach((p, i) => {
                    p.x += p.speed * Math.cos(p.rotation * Math.PI / 180);
                    p.y += p.speed * Math.sin(p.rotation * Math.PI / 180);

                    p.opacity -= 0.005;
                    p.speed *= p.friction;
                    p.radius *= p.friction;
                    p.yVel += p.gravity;
                    p.y += p.yVel;

                    if(p.opacity < 0 || p.radius < 0) return;

                /*    ctx.beginPath();
                    ctx.globalAlpha = p.opacity;
                    ctx.fillStyle = p.color;
                    ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI, false);
                    ctx.fill();
                    */
                   this.drawHeart(p.x,p.y,0,0,p.radius,p.radius,p.color,p.opacity,ctx);
                });
            }
        }
        return ctx;
        
    }
    drawHeart(fromx, fromy, tox, toy,lw,hlen,color,opacity,ctx) {

        var x = fromx;
        var y = fromy;
        var width = lw ;
        var height = hlen;
      
        ctx.save();
        ctx.beginPath();
        
        ctx.globalAlpha = opacity;
        var topCurveHeight = height * 0.3;
        ctx.moveTo(x, y + topCurveHeight);
        // top left curve
        ctx.bezierCurveTo(
          x, y, 
          x - width / 2, y, 
          x - width / 2, y + topCurveHeight
        );
      
        // bottom left curve
        ctx.bezierCurveTo(
          x - width / 2, y + (height + topCurveHeight) / 2, 
          x, y + (height + topCurveHeight) / 2, 
          x, y + height
        );
      
        // bottom right curve
        ctx.bezierCurveTo(
          x, y + (height + topCurveHeight) / 2, 
          x + width / 2, y + (height + topCurveHeight) / 2, 
          x + width / 2, y + topCurveHeight
        );
      
        // top right curve
        ctx.bezierCurveTo(
          x + width / 2, y, 
          x, y, 
          x, y + topCurveHeight
        );
      
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
        ctx.restore();
      
      }
     r = (a, b, c) => parseFloat((Math.random() * ((a ? a : 1) - (b ? b : 0)) + (b ? b : 0)).toFixed(c ? c : 0));

    //document.querySelector('.js-explosion').addEventListener('mouseover', e => explode(e.pageX, e.pageY));
}